import React from "react";
import { TRADE_LOG_FILTER_INPUT_CLASS } from "@/components/trade-filter-selects";
import { Field, FieldLabel } from "@/components/ui/field";
import { Input as ShadcnInput } from "@/components/ui/input";
import {
  MAX_COMPARISON_RUN_TITLE_LENGTH,
  normalizeComparisonRunSavedTitle,
} from "./simulatorComparisonTypes";

const SIMULATOR_OPTION_FIELD_LABEL_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-[color:var(--brand-tropical-surf)]";

export function normalizeMandatorySimulatorRunTitle(raw: string): string {
  return normalizeComparisonRunSavedTitle(raw);
}

export function NextRunTitleField(props: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}): React.ReactElement {
  return (
    <Field
      className={props.className ?? "w-[300px] min-w-[300px] shrink-0"}
      data-simulator-toolbar-field=""
      data-field="title"
    >
      <FieldLabel htmlFor={props.id} className={SIMULATOR_OPTION_FIELD_LABEL_CLASS}>
        Next run title
      </FieldLabel>
      <div data-trade-filter-bar="" data-trade-filter-bar-layout="full" className="w-full min-w-0">
        <ShadcnInput
          id={props.id}
          type="text"
          name="simulator-run-title"
          value={props.value}
          onChange={(e) => props.onChange(e.target.value.slice(0, MAX_COMPARISON_RUN_TITLE_LENGTH))}
          placeholder={`Required. Max ${MAX_COMPARISON_RUN_TITLE_LENGTH} characters.`}
          maxLength={MAX_COMPARISON_RUN_TITLE_LENGTH}
          required
          aria-required
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          data-1p-ignore
          data-lpignore="true"
          className={TRADE_LOG_FILTER_INPUT_CLASS}
        />
      </div>
    </Field>
  );
}
